module.exports = __webpack_public_path__ + "static/media/score_five.33ee37ca.png";